module.exports = __webpack_public_path__ + "static/img/tableHead1.6bdd6b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/tableHead1.png
// module id = hVtL
// module chunks = 2